import {withComponent} from '../../hoc/withComponent';
import {DialogBase} from './DialogBase';

export const withDialog = withComponent(DialogBase);
